import { render, staticRenderFns } from "./TalentMatrix.vue?vue&type=template&id=2f3a15fe&scoped=true"
import script from "./TalentMatrix.vue?vue&type=script&lang=js"
export * from "./TalentMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a15fe",
  null
  
)

export default component.exports